<template>
  <form class="mt-2" id="form-modal">
    <!-- description input -->
    {{getDemoUrlDetail}}
    <div class="form-group" v-if="demo_url">
      <p>Trial end date is {{demo_url.trial_end_date |formatTrialDate}}</p>
    </div>
    <div class="form-group" >
      <label class="label-form">Trial End Date<span style="color: red">*</span>:</label>
      <input class="form-control" :min="demo_url.trial_end_date" type="date"  v-model="trial_date"/>
      
    </div>
    

    <!-- buttons -->
    <div class="form-group text-right">
      
      <button  type="button" class="btn btn-secondary" data-dismiss="modal">
        Cancel
      </button>
      <!-- <button type="button"  v-if=" !trial_in_days" :style= "[isMiniLoading ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" :disabled="isMiniLoading" class="btn btn-default ml-1" @click="updateDemoUrlLink">
        <font-awesome-icon v-if="isMiniLoading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
        Save
      </button> -->
      <button type="button"  :style= "[isMiniLoading ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" :disabled="isMiniLoading" class="btn btn-default ml-1" @click="updateDemoUrlLink">
        <font-awesome-icon v-if="isMiniLoading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
        Update
      </button>

     

    </div>

    <table class="table table-bordered table-hover  mt-5 text-center">
       <th style="color:#48a6a6;" colspan="3"><b>Trial Date History</b></th>
       <tbody>
        <tr>
                <th style="width: 35%;">Trial End date</th>
                <th style="width: 30%;">At</th>
                <th style="width: 35%;">Updated By</th>
              </tr>
              
              <tr class="mt-2" v-for="(trial, index) in trial_history" :key="trial.id">
                <td  style="width: 35%;"> <p style="white-space: break-spaces">{{ trial.trial_end_date |formatTrialDate }}</p> </td>
                <td  style="width: 30%;"> <p style="white-space: break-spaces">{{ trial.created_at |formatCreatedAtDate}}</p> </td>
                <td  v-if="trial.updated_by" style="width: 35%;"> <p style="white-space: break-spaces">{{ trial.first_name+" "+trial.last_name}}</p> </td>
                <td v-else style="width: 35%;"> <p style="white-space: break-spaces"> ---</p> </td>
                
              </tr>
              <h5 style="text-align: center; position: absolute; transform: translateX(40px); margin-top: 24px;" v-if="trial_history.length<1">
      No Trial History Along This Organization.
    </h5>
            </tbody>
          </table>
<!-- table to show history  -->
  </form>

</template>
<script>
  // import Multiselect from 'vue-multiselect';
  import axios from "axios";
  import moment from "moment";
  Vue.filter("formatTrialDate", function (value) {
    if (value != "0000-00-00" && value != null) {
      return moment(String(value)).format("MMM DD,Y");
    }
  });
  
  Vue.filter("formatCreatedAtDate", function (value) {
    if (value != "0000-00-00" && value != null) {
      return moment(String(value)).format("DD MMM,Y h:mm a");
    }
  });
  export default {
    props: ["action", "formData", "pageNumber"],
    data: function () {
      return {
        isMiniLoading: false,
        trial_date: "",
        video_link:"",
        demo_url:"",
        trial_history:"",
        emptydata:false,
        id:"",
        flag: false,
        today:new Date().toISOString().slice(0, 10),
        // trial_in_days: false,
      };
    },
    // created:function(){
    //   this.trial_in_days = this.formData.trial_in_days;
    // },
    computed: {
      getDemoUrlDetail: function () {
        this.trial_date = "";
        axios
          .get("admin/organization/check_trial_end_date?org_id=" + this.formData.org_id)
          .then((response) => {
            let data = response.data.demo_url;
            if (data != null) {
              this.demo_url = data;
            }
            this.flag = false;
          });
          this.gettrialhistory();
    
        },
    },
   

    methods: {
      updateDemoUrlLink() {
        this.isMiniLoading = true; 

        if(this.trial_date==""){
              this.$toast.warning("Date Field is Required..");  
              this.isMiniLoading = false;
        }else{
          this.$store
            .dispatch("organizations/updateTrialDate", [this.demo_url.id,this.trial_date,''])
            .then(() => {
              this.isMiniLoading = false;
              this.getdemourls();
              this.gettrialhistory();
              this.$toast.success("Trial end date has been updated successfully");
              this.trial_date="";
              this.flag = false;
            });
        }
      },
      getdemourls() {
        axios
          .get("/admin/organization/check_trial_end_date?org_id=" + this.formData.org_id)
          .then((response) => {
            let data = response.data.demo_url;
            if (data != null) {
              this.demo_url = data;
            }
           this.flag = false;
           this.trial_date = "";
          });
      },
      gettrialhistory() {
        axios
          .get("/admin/organization/get_trial_date_history?org_id=" + this.formData.org_id)
          .then((response) => {
            let data = response.data.trial_history;
            if (data != null) {
              this.trial_history = data;
            }
          });
      },

    },
  };
</script>
<style scoped>
.table th, .table td {
  padding: 0.75rem 0.5rem;
}
</style>